(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/game-rules-page-link.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/game-rules-page-link.js');
'use strict';

const isNativeApp = svs.core.config.data.svsconfig.isNativeApp;
const GameRulesPageLink = () => React.createElement("a", {
  className: "u-text-decoration-underline",
  href: svs.core.urlMapping.get('termsIntegrityRules'),
  rel: "noreferrer",
  target: isNativeApp ? '' : '_blank'
}, "spelregler");
svs.playerRegistration.components.GameRulesPageLink = GameRulesPageLink;

 })(window);